import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpRequestService } from 'src/app/all-modules/shared/services/http-request.service';
import { ApiUrlConstants } from 'src/app/all-modules/shared/constants/api_url_constants';
import { ApiResponse } from 'src/app/all-modules/shared/common-model/common.model';
import { environment } from 'src/environments/environment';
import { PublicGalleryViewModel, GalleryCommentsViewModel, AddGalleryCommentPublicDTO } from '../model/gallery.model';

@Injectable({ providedIn: 'root' })
export class GalleryService {
  constructor(private httpRequestService: HttpRequestService) { }

  getPhotoGallery(token: string, contactRef: string): Observable<PublicGalleryViewModel> {
    const c = contactRef ? `?c=${encodeURIComponent(contactRef)}` : '';
    return this.httpRequestService.getData<PublicGalleryViewModel>(`${ApiUrlConstants.publicGetPhotoGallery}${token}${c}`);
  }
  getPhotoComments(token: string, galleryPhotoId: string): Observable<GalleryCommentsViewModel> {
    return this.httpRequestService.getData<GalleryCommentsViewModel>(`${ApiUrlConstants.publicGetGalleryPhotoComments}${token}/${galleryPhotoId}`);
  }
  addComment(token: string, dto: AddGalleryCommentPublicDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(`${ApiUrlConstants.publicAddGalleryComment}${token}`, dto);
  }
  imageUrl(token: string, galleryPhotoId: string): string {
    return `${environment.apiUrl}/api/PublicGallery/GetGalleryImage/${token}/${galleryPhotoId}`;
  }
}
